import { SS_NAVIGATION_REPORTS } from '@/constants';

export const getStorageReportList = () => {
  const reports = sessionStorage.getItem(SS_NAVIGATION_REPORTS);
  if (reports) {
    try {
      return JSON.parse(reports) as string[];
    } catch (e) {}
  }
  return [];
};

export const setStorageReportList = (list: string[]) => {
  sessionStorage.setItem(SS_NAVIGATION_REPORTS, JSON.stringify(list));
};
